export default "__VITE_ASSET__DnNv9ulw__"